import styled from 'styled-components';
export { Stack, Row, Card, Small, Field, Quote } from '@/features/discussion-tools/styles';
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  fieldset {
    border: 1px solid ${({ theme }) => theme.color.hairSoft};
    border-radius: ${({ theme }) => theme.radius.md};
    padding: 12px;
    min-width: 0;
  }
  legend {
    padding: 0 6px;
    font-weight: 600;
  }
  textarea {
    min-height: 100px;
    resize: vertical;
    padding: 10px;
    font: inherit;
    color: ${({ theme }) => theme.color.textPrimary};
    background: ${({ theme }) => theme.color.surface};
    border: 1px solid ${({ theme }) => theme.color.hairSoft};
    border-radius: ${({ theme }) => theme.radius.sm};
  }
  input:focus-visible,
  select:focus-visible,
  textarea:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
`;
export const Check = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  input {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    accent-color: ${({ theme }) => theme.color.accentCyan};
  }
`;
